import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'building_complexes',
    component: Children,

    children: [
      {
        path: '',
        name: 'building_complexes',
        component: () =>
          import('@/modules/building_complexes/pages/BuildingComplexesPage')
      },

      {
        path: 'create',
        name: 'building_complexes.create',
        component: () =>
          import('@/modules/building_complexes/pages/BuildingComplexCreatePage')
      },

      {
        path: ':id',
        name: 'building_complexes.show',
        component: () =>
          import('@/modules/building_complexes/pages/BuildingComplexShowPage'),
        props: route => ({
          id: Number(route.params.id),
          selectedBuilding: Number(route.params.selectedBuilding)
        })
      }
    ]
  }
];

export default routes;
